import { Reveal, Overline } from "./Reveal";
import { PILLARS } from "@/data/content";

export default function Differential() {
  return (
    <section className="py-28 md:py-40" data-testid="differential-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <Overline>O nosso diferencial</Overline>
              <h2 className="mt-6 font-display text-4xl font-medium leading-[1.05] tracking-tight text-royal-deep md:text-6xl">
                Perto de cada projeto, <br />
                <em className="text-royal">do início ao fim.</em>
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-8 text-base leading-relaxed text-foreground/80 md:text-lg">
                Na Creative, a estratégia e a produção criativa vivem na mesma equipa, sem
                departamentos, sem intermediários.
              </p>
              <p className="mt-5 text-base leading-relaxed text-muted-foreground">
                Isso significa comunicação mais simples, decisões mais rápidas e uma relação muito
                mais próxima com cada cliente.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            <div className="grid gap-px overflow-hidden rounded-xl border border-royal-line bg-royal-line sm:grid-cols-2">
              {PILLARS.map((p, i) => (
                <Reveal key={p.n} delay={i * 0.08} className="h-full">
                  <div
                    className="group flex h-full flex-col justify-between bg-white p-8 transition-colors duration-500 hover:bg-royal md:p-10"
                    data-testid={`pillar-${p.n}`}
                  >
                    <span className="font-display text-4xl font-medium italic text-royal/30 transition-colors duration-500 group-hover:text-white/50">
                      {p.n}
                    </span>
                    <div className="mt-12">
                      <h3 className="font-display text-xl font-medium text-royal-deep transition-colors duration-500 group-hover:text-white md:text-2xl">
                        {p.title}
                      </h3>
                      <p className="mt-3 text-sm leading-relaxed text-muted-foreground transition-colors duration-500 group-hover:text-white/75">
                        {p.desc}
                      </p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
